import { usePaywall } from "@/hooks/usePaywall";
import { TrialBanner } from "./TrialBanner";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ShieldX } from "lucide-react";

interface PaywallGuardProps {
  children: React.ReactNode;
  /** If true, blocks rendering children when not allowed. If false, just shows banner. */
  block?: boolean;
}

export function PaywallGuard({ children, block = false }: PaywallGuardProps) {
  const { data: status, isLoading } = usePaywall();
  const navigate = useNavigate();

  if (isLoading || !status) return <>{children}</>;

  if (block && !status.allowed) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] text-center space-y-4 p-8">
        <ShieldX className="w-16 h-16 text-muted-foreground" />
        <h2 className="text-xl font-semibold">Acesso Bloqueado</h2>
        <p className="text-muted-foreground max-w-md">
          {status.reason === "trial_expired" && "Seu período de trial expirou. Escolha um plano para continuar usando todas as funcionalidades."}
          {status.reason === "limit_reached" && "Você atingiu o limite do seu plano atual. Faça upgrade para continuar."}
          {status.reason === "suspended" && "Sua conta está suspensa por falta de pagamento. Atualize seus dados de pagamento."}
        </p>
        <Button onClick={() => navigate("/billing")}>Ir para Billing</Button>
      </div>
    );
  }

  return (
    <div>
      <TrialBanner status={status} />
      {children}
    </div>
  );
}
